import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Filtros de uma tela do admin guardados na query string: a busca vira link
 * (outra seção pode abrir esta já filtrada) e sobrevive a F5 e ao "voltar".
 *
 * Devolve `[filters, apply, key]`: `filters` tem todas as `keys` ('' quando
 * ausente), `apply(next)` grava só as preenchidas e `key` muda quando a URL
 * muda (use como dependência para recarregar).
 */
export default function useUrlFilters(keys) {
    const [params, setParams] = useSearchParams();
    const key = params.toString();

    const filters = useMemo(
        () => Object.fromEntries(keys.map((k) => [k, params.get(k) || ""])),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [key]
    );

    const apply = (next) => {
        const out = new URLSearchParams();
        keys.forEach((k) => {
            const v = next[k];
            if (v !== undefined && v !== null && String(v).trim() !== "") out.set(k, String(v).trim());
        });
        setParams(out);
    };

    return [filters, apply, key];
}
